module.exports = __webpack_public_path__ + "img/ico_remove.f0b09977.svg";